import Enum from "../../../../../../enums/Enum";

const NutritionEnum = new Enum({
    LARGE_MEAL: {name: "1-3 Large Meals"},
    MODERATE_MEALS_AND_SNACKS: {name: "1-3 Moderate Meals and Snacks"},
    MEAL_PER_DAY: {name: "1 Meal Per Day"},
    OTHER: {name: "Other"}
});

export default NutritionEnum;